/**
 * Sender domains ConfirmPay can parse, shown to orgs so they can build their forwarding filter.
 * KEEP IN SYNC with email-worker/src/parsers.ts, the source of truth for what gets matched.
 */
export const BANK_SENDER_DOMAINS: { label: string; domains: string[] }[] = [
  { label: "DBS / POSB", domains: ["dbs.com", "posb.com.sg"] },
  { label: "OCBC", domains: ["ocbc.com"] },
  { label: "UOB", domains: ["uob.com.sg"] },
  { label: "Standard Chartered", domains: ["standardchartered.com"] },
  { label: "Maybank", domains: ["maybank.com.sg", "maybank2u.com.sg"] },
  { label: "HSBC", domains: ["hsbc.com.sg"] },
  { label: "Citibank", domains: ["citibank.com", "citi.com"] },
  { label: "CIMB", domains: ["cimb.com", "cimbbank.com.sg"] },
  { label: "Trust Bank", domains: ["trustbank.sg"] },
  { label: "GXS Bank", domains: ["gxs.com.sg"] },
];

export const ALL_BANK_DOMAINS = BANK_SENDER_DOMAINS.flatMap((b) => b.domains);

/** Ready-to-paste Gmail filter "From" value. */
export const GMAIL_FROM_FILTER = ALL_BANK_DOMAINS.join(" OR ");
